'use client';

import Script from 'next/script';
import useDeferredMount from '@/utils/useDeferredMount';

export default function UserWayScript() {
  const ready = useDeferredMount();
  if (!ready) return null;

  return (
    <>
      <Script
        id="userway-config"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `var _userway_config = { account: "RF3LDqOACA" };`,
        }}
      />
      <Script
        id="userway-widget"
        src="https://cdn.userway.org/widget.js"
        strategy="lazyOnload"
        onLoad={() => {
          document.addEventListener('userway:init_completed', (e) => {
            if (typeof window !== 'undefined' && e.detail.userWayInstance) {
              e.detail.userWayInstance.iconVisibilityOff();
            }
          });
        }}
      />
    </>
  );
}
